import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import CatalogoOrganizacionPrincipal from "../../catalogos/catalogoOrgaPrincipal";
import { validaSoloNumero } from "../../util/varios";

import { SuccessButton, DangerButton } from "../../ui/buttons/Button";
import { Input, Textarea, SearchInput, Select } from "../../ui/inputs/Input";

export const ActualizarEfiscal = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [mostrar3, setMostrar3] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idefiscal: "",
    descriptor: "",
    anio: "",
    observaciones: "",
    statusorg: "",
    statuspresup: "",
    statuspuc: "",
    statuscat: "",
    idorganizacion: "",
    activo: false,
  });
  const txtIdd = useRef();
  const txtDescrip = useRef();
  const txtAnio = useRef();
  const txtObser = useRef();
  const txtStatuscat = useRef();
  const txtStatusor = useRef();
  const txtStatuspre = useRef();
  const txtStatuspuc = useRef();
  const txtCodigo = useRef();
  const txtDescripor = useRef();

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtAnio.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Año del Ejercicio Fiscal",
        icono: "informacion",
      });
      sigue = false;
      txtAnio.current.focus();
    } else if (txtDescrip.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Descripción del Ejercicio Fiscal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDescrip.current.focus();
    } else if (txtObser.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Observación del Ejercicio Fiscal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtObser.current.focus();
    } else if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Organizacion no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtDescripor.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Organización no Existe o Esta Vacia",
        icono: "informacion",
      });
      sigue = false;
      txtDescripor.current.focus();
    } else if (txtStatusor.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Estatus de la Organización",
        icono: "informacion",
      });
      sigue = false;
      txtStatusor.current.focus();
    } else if (txtStatuspuc.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Estatus del PUC",
        icono: "informacion",
      });
      sigue = false;
      txtStatuspuc.current.focus();
    } else if (txtStatuspre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Estatus del Presupuesto",
        icono: "informacion",
      });
      sigue = false;
      txtStatuspre.current.focus();
    } else if (txtStatuscat.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Estatus de la Categoria",
        icono: "informacion",
      });
      sigue = false;
      txtStatuscat.current.focus();
    } else if (sigue) {
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const seleccionarOrganizacion = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idorganizacion > 0) {
            txtDescripor.current.value = response.data.nombre;
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La Organización no Existe",
              icono: "informacion",
            });
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/comun/actualizarefiscal/${operacion}`;
    let body;
    setActivate(true);

    body = {
      nid: parseInt(txtIdd.current.value),
      des: txtDescrip.current.value.trim(),
      nanio: txtAnio.current.value.trim(),
      obser: txtObser.current.value.trim(),
      staorg: txtStatusor.current.value.trim(),
      stapre: txtStatuspre.current.value.trim(),
      stapuc: txtStatuspuc.current.value.trim(),
      stacat: txtStatuscat.current.value.trim(),
      idorg: parseInt(txtCodigo.current.value),
      actv: false,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idefiscal: "",
      descriptor: "",
      anio: "",
      observaciones: "",
      statusorg: "",
      statuspresup: "",
      statuspuc: "",
      statuscat: "",
      idorganizacion: "",
      activo: false,
    });
    setActivate(false);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const catalogoOrg = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const handleAceptaCatalogoOrg = (idorganizacion, nombre) => {
    setMostrar3(false);
    txtCodigo.current.value = idorganizacion;
    txtDescripor.current.value = nombre;
  };

  const handleCancelara = () => {
    setMostrar3(false);
  };

  const handleOrganizacion = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtDescripor.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarOrganizacion(event.target.value);
      }
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.fiscal);
        } else {
          txtCodigo.current.value = "";
          txtDescripor.current.value = "";
          txtStatuscat.current.value = "";
          txtStatusor.current.value = "";
          txtStatuspre.current.value = "";
          txtStatuspuc.current.value = "";
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Agregar Ejercicio Fiscal."
              : operacion === 2
                ? "Editar Ejercicio Fiscal."
                : operacion === 3
                  ? "Eliminar Ejercicio Fiscal."
                  : "Consultar Ejercicio Fiscal."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <CatalogoOrganizacionPrincipal
          show={mostrar3}
          onHideCancelar={handleCancelara}
          onHideAceptaCatOrg={handleAceptaCatalogoOrg}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="container-fluid rounded">
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between border-azul rounded">
                <legend className="float-none m-0 w-auto">Datos</legend>

                <div className='col-4 col-md-2 m-0 mb-2 p-0'>
                  <Input label='Código'
                    disabled={true}
                    value={values ? values.idefiscal.trim() : ""}
                    id="inputCedula"
                    ref={txtIdd}
                  />
                </div>
                <div className="col-4 col-md-2 m-0 mb-2 p-0">
                  <Input label='Año'
                    disabled={
                      operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    autoComplete="off"
                    maxLength="4"
                    onChangeCapture={handleInputNumChange}
                    defaultValue={values ? values.anio : ""}
                    ref={txtAnio}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea label='Descripción'
                    type="textarea"
                    style={{ height: 50 }}
                    autoComplete="off"
                    defaultValue={values ? values.descriptor.trim() : ""}
                    disabled={
                      operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    id="inputDireccion"
                    ref={txtDescrip}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea label='Observaciones'
                    type="textarea"
                    style={{ height: 50 }}
                    autoComplete="off"
                    className="form-control text-uppercase"
                    defaultValue={values ? values.observaciones.trim() : ""}
                    disabled={
                      operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    id="inputDireccion"
                    ref={txtObser}
                  />
                </div>
              </fieldset>

              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between border-azul rounded">
                <legend className="float-none m-0 w-auto">
                  Datos de la Organización
                </legend>

                <div className="col-3 m-0 mb-2 p-0">
                  <SearchInput label='Código'
                    onChange={handleOrganizacion}
                    disabled={
                      operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    defaultValue={
                      props.organiza ? props.organiza.idorganizacion : ""
                    }
                    onClickButton={catalogoOrg}
                    disabledButton={
                      operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    id="inputCedula"
                    ref={txtCodigo}
                  />
                </div>
                <div className='col-12 m-0 mb-2 p-0'>
                  <Textarea label='Descripción'
                    type="textarea"
                    style={{ height: 50 }}
                    disabled={true}
                    defaultValue={
                      props.organiza ? props.organiza.nombre.trim() : ""
                    }
                    placeholder="Descripción de la Unidad Ejecutora"
                    id="inputDireccion"
                    ref={txtDescripor}
                  />
                </div>
                <div className="col-xl-3 col-lg-6 m-0 mb-2 p-0 pr-1">
                  <Select label='Estatus Organización:'
                    disabled={
                      operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    defaultValue={
                      props.fiscal ? props.fiscal.statusorg : ""
                    }
                    id="inputSexo"
                    ref={txtStatusor}
                    options={[
                      { value: "", label: "--Seleccione--" },
                      { value: "222", label: "CREADA" },
                      { value: "111", label: "POR CREAR" },
                    ]}
                  />
                </div>
                <div className="col-xl-3 col-lg-6 m-0 mb-2 p-0 pl-1">
                  <Select label='Estatus del Puc:'
                    disabled={
                      operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    defaultValue={
                      props.fiscal ? props.fiscal.statuspuc : ""
                    }
                    id="inputSexo"
                    ref={txtStatuspuc}
                    options={[
                      { value: "", label: "--Seleccione--" },
                      { value: "22", label: "CARGADA" },
                      { value: "11", label: "POR CARGAR" },
                    ]}
                  />
                </div>
                <div className="col-xl-3 col-lg-6 m-0 mb-2 p-0 pr-1">
                  <Select label='Estatus del Presupuesto:'
                    disabled={
                      operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    defaultValue={
                      props.fiscal ? props.fiscal.statuspresup : ""
                    }
                    id="inputSexo"
                    ref={txtStatuspre}
                    options={[
                      { value: "", label: "--Seleccione--" },
                      { value: "1", label: "POR APROBAR" },
                      { value: "2", label: "APROBADO" },
                      { value: "3", label: "CERRADO" },
                    ]}
                  />
                </div>
                <div className="col-xl-3 col-lg-6 m-0 mb-2 p-0 pl-1">
                  <Select label='Estatus de la Categoria:'
                    disabled={
                      operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    defaultValue={
                      props.fiscal ? props.fiscal.statuscat : ""
                    }
                    id="inputSexo"
                    ref={txtStatuscat}
                    options={[
                      { value: "", label: "--Seleccione--" },
                      { value: "32", label: "CARGADA" },
                      { value: "31", label: "POR CARGAR" },
                    ]}
                  />
                </div>

              </fieldset>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}>
          Aceptar
        </SuccessButton>
        <DangerButton
          onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
